import { default as UAParser_ } from "ua-parser-js";

const UAParser = new UAParser_();

export const browserName = UAParser?.getBrowser?.()?.name;
export const deviceType = UAParser?.getDevice?.()?.type;